export const DEFAULT_COUPON_CONTENT = {
  page_title: "Buy & Win Raffle Coupon",
  logo_image: "/old_logo.png",
  logo_alt: "Orbit Kuwait",
  raffle_background_image: "/images/buy-win-raffle.png",
  promo_text: "Get a free raffle coupon with every product you purchase!",
  brand_title: "Orbit Kuwait",
  brand_subtitle: "Orbit Kuwait",
  terms_title: "Terms & Conditions",
  terms_items: [
    "Coupon for every purchase above 10 KD",
    "Bring original invoice and raffle coupon",
  ],
  show_promotion_dates: "Y",
  promotion_label: "Promotion",
  contact_mobile: "+965 6600 0000",
  contact_location: "Shop No. 1, Road 1, Block 1, Kuwait",
  side_note: "* Terms and conditions apply",
};

export const mergeCouponContent = (content = {}) => ({
  ...DEFAULT_COUPON_CONTENT,
  ...content,
  terms_items: content.terms_items?.length
    ? content.terms_items
    : DEFAULT_COUPON_CONTENT.terms_items,
});
